import { convertNativeToCustom } from "services/utility/customFields";

export function beforeSave(record) {
  const newRecord = { ...record };

  newRecord.customFields = convertNativeToCustom(record.customFields);

  return newRecord;
}
